import request from '@/utils/request'
import streamRequest from '@/utils/streamRequest'

export function models(params) {
  return request({
    url: '/client/chat/models',
    mockPath: '/models',
    method: 'get',
    params
  })
}


export function sessions(params) {
  return request({
    url: '/client/chat/sessions',
    mockPath: '/sessions',
    method: 'get',
    params
  })
}


export function sessionsDel(ids) {
  return request({
    url: '/client/chat/sessions/' + ids,
    mockPath: '/submit',
    method: 'delete',
  })
}

export function sessionsEdit(sessionId, sessionTitle) {
  return request({
    url: `/client/chat/session/${sessionId}`,
    mockPath: '/submit',
    method: 'put',
    data: {
      sessionTitle
    }
  })
}

export function messages(sessionId) {
  return request({
    url: `/client/chat/session/${sessionId}/messages`,
    mockPath: '/messages',
    method: 'get'
    
  })
}


export function completions(data, onStart,onChunk, onComplete, onError) {
  return streamRequest({
    url: '/client/chat/completions',
    mockPath: 'http://api.example.com/chat',
    method: 'post',
    body:data,
  }, onStart,onChunk, onComplete, onError)
}